/**
 *  @class
 *  @function BobsleighCollage
 *  Scroll-in animations. Uses the theme's global GSAP + ScrollTrigger
 *  (animations.min.js); falls back to IntersectionObserver, and to
 *  no-op (everything visible) when neither is available or the user
 *  prefers reduced motion.
 */
if (!customElements.get('bobsleigh-collage')) {
	class BobsleighCollage extends HTMLElement {
		connectedCallback() {
			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

			this.medias = this.querySelectorAll('.bobsleigh-collage__media, .bobsleigh-collage__track-media');
			this.contents = this.querySelectorAll('.bobsleigh-collage__content');
			this.stats = this.querySelectorAll('.bobsleigh-collage__stat');

			if (window.gsap && window.ScrollTrigger) {
				this.initGsap();
			} else {
				this.initObserver();
			}
		}

		initGsap() {
			const ease = (window.theme && window.theme.settings && window.theme.settings.animation_easing) || 'power2.out';
			this.medias.forEach((el) => {
				window.gsap.fromTo(el,
					{ opacity: 0, y: 60, scale: 1.04 },
					{
						opacity: 1, y: 0, scale: 1, duration: 1, ease: ease,
						scrollTrigger: { trigger: el, start: 'top 88%' }
					}
				);
			});
			this.contents.forEach((el) => {
				window.gsap.fromTo(el,
					{ opacity: 0, y: 30 },
					{
						opacity: 1, y: 0, duration: 0.8, ease: ease, delay: 0.15,
						scrollTrigger: { trigger: el, start: 'top 90%' }
					}
				);
			});
			this.stats.forEach((el) => {
				window.gsap.fromTo(el,
					{ opacity: 0, y: 20 },
					{
						opacity: 1, y: 0, duration: 0.7, ease: ease, delay: 0.3,
						scrollTrigger: { trigger: el, start: 'top 95%' }
					}
				);
			});
		}

		initObserver() {
			const els = [...this.medias, ...this.contents, ...this.stats];
			els.forEach((el) => el.classList.add('collage-anim'));
			const io = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('collage-anim--in');
						io.unobserve(entry.target);
					}
				});
			}, { rootMargin: '0px 0px -10% 0px' });
			els.forEach((el) => io.observe(el));
		}
	}
	customElements.define('bobsleigh-collage', BobsleighCollage);
}
